module.exports = __webpack_public_path__ + "img/cn_pocket-19.94548c9.jpg";